import React from 'react'

function SubscriptionManagement() {
  return (
    <div>
      this page is to manage subscriptions
    </div>
  )
}

export default SubscriptionManagement
